import { ArticleDto } from "api";
import { Action } from "redux";

export enum TrainingActionType {
  VisibleArticle = "Training/VisibleArticle"
}
export interface VisibleArticle extends Action {
  type: TrainingActionType.VisibleArticle;
  article: ArticleDto | undefined;
}

export const TrainingActions = {
  visibleArticle: (article: ArticleDto | undefined): VisibleArticle => ({
    type: TrainingActionType.VisibleArticle,
    article
  })
};
export type TrainingActions = VisibleArticle;
